import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'


import ContentHeader from '../common/template/contentHeader'
import Content from '../common/template/content'
import ValueBox from '../common/widget/valueBox'
import Row from '../common/layout/row'




class Dashboard extends Component {

  componentWillMount() {
  }


  
  
  render() {
    return (
      <div>
        <h1>Seja Bem Vindo ao Gerenciador de Boletos</h1>
        <div>
       
        </div>
      </div>

    )
  }
}

const mapStateToProps = state => ({
  // summary: state.dashboard.summary
})

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(Dashboard)



// WEBPACK FOOTER //
// ./src/dashboard/dashboard.jsx